export const initialState = {
  errorCode: "",
  errorMessage: "",
  errorLogLoading: false,
  errorLogSuccess: false,
  errorLogError: false,
  errorLogCount: 0,
  errorLog: [],
};
